import { render } from "./BasketballMatchScoreBoard.vue?vue&type=template&id=1e932810&scoped=true"
import script from "./BasketballMatchScoreBoard.vue?vue&type=script&lang=js"
export * from "./BasketballMatchScoreBoard.vue?vue&type=script&lang=js"

import "./BasketballMatchScoreBoard.vue?vue&type=style&index=0&id=1e932810&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-ASPN/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e932810"]])

export default __exports__